module.exports = __webpack_public_path__ + "img/law2.26f68442.webp";